module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_8017.f7605137.png";